var React = require('react');

function InstagramIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.001 0h-15C2.239 0 0 2.239 0 5v15.001C0 22.759 2.239 25 5 25h15.001C22.759 25 25 22.76 25 20.001v-15C24.998 2.239 22.76 0 20.001 0m-2.503 3.75h3.751V7.5H17.5V3.75zM12.5 7.5c2.762 0 5 2.24 5 5s-2.238 5-5 5-4.999-2.24-4.999-5c0-2.763 2.237-5 5-5m9.999 12.501c0 1.38-1.122 2.5-2.5 2.5H5.001C3.62 22.5 2.5 21.38 2.5 20v-8.752h2.627c-.07.41-.126.824-.126 1.25 0 4.144 3.357 7.502 7.498 7.502 4.14 0 7.502-3.356 7.502-7.502 0-.426-.058-.84-.126-1.25H22.5v8.752H22.5z"}));
}

InstagramIcon.defaultProps = {"viewBox":"0 0 25 25"};

module.exports = InstagramIcon;

InstagramIcon.default = InstagramIcon;
